import { Box, Chip } from '@mui/material'
import MUIInput from './MUIInput'
import { LANGS_WITHOUT_TW } from '../../../Constants/lang'

const DEFAULT_LOCALES = LANGS_WITHOUT_TW

const localeColors = {
  EN: '#4A90D9',
  ZH_CN: '#E74C3C',
  ZH_HK: '#2ECC71',
  ZH_TW: '#F39C12',
}

export default function MultiLangInput({ langObj = {}, objKey, onChangeMultiLangInput, disabled, error, label, required, multiline = true, locales }) {
  const localeList = locales || DEFAULT_LOCALES

  return (
    <Box sx={{ gridColumn: '1 / -1', display: 'grid', rowGap: 1.5, columnGap: 1.5, gridTemplateColumns: `repeat(${localeList.length}, 1fr)` }}>
      {localeList.map((lang) => {
        const value = (langObj && langObj[lang]) || ''
        const color = localeColors[lang] || '#94a3b8'

        return (
          <Box key={`${lang}-${label}`} sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            <Chip
              label={lang}
              size="small"
              sx={{
                height: 18, fontSize: 9, fontWeight: 700, alignSelf: 'flex-start',
                bgcolor: color, color: '#fff',
                '& .MuiChip-label': { px: 0.8 },
              }}
            />
            <MUIInput
              required={required}
              multiline={multiline}
              rows={multiline ? 5 : 1}
              label={''}
              variant="filled"
              name={lang}
              value={value}
              onChange={(e) => onChangeMultiLangInput(objKey, lang, e.target.value)}
              disabled={disabled}
              error={error ? error[lang] : undefined}
            />
          </Box>
        )
      })}
    </Box>
  )
}
